import { Injectable } from '@angular/core';
// import { NgxIndexedDBService } from 'ngx-indexed-db';
import Dexie from 'dexie';

class DigitalEyesDb extends Dexie {

  public AddressPhotoFilesDetails: Dexie.Table;
  public InspectionFilesDetails: Dexie.Table; // id is number in this case
  public InspectionTaskDetails: Dexie.Table;
  public MetaFileDetails: Dexie.Table;
  public ChecklistDetail: Dexie.Table;
  public TaskChecklistDetail: Dexie.Table;
  public privateDetectTable: Dexie.Table;

  public: Dexie.Table;
  public constructor() {
    super("DigitalEyesDb");
    try {
      this.version(1).stores({
        AddressPhotoFilesDetails: "++AddressFileId,AddressProofImg,taskId,UserID,zoneDetails,FileType,LocalFileUrl,FileSize,FileName,UploadStatus,RetryHitting,MetaData,ServerFileID,ServerFileName,LiveUrl",
      });
      this.AddressPhotoFilesDetails = this.table("AddressPhotoFilesDetails");
    } catch (error) {
    }
  }


}
@Injectable({
  providedIn: 'root'
})
export class IdbService {
  db: any;
  idbservice: any;
  constructor() {

  }
  async truncateData() {
    this.db = new DigitalEyesDb();
    await this.db.AddressPhotoFilesDetails.clear();
  }
  async addressVerificationFilesDetails(obj) {
    this.db = new DigitalEyesDb();
    const id = await this.db.AddressPhotoFilesDetails.add(obj);
  }
  // Address upload
  async getAddressTaskFileDetailsToUpload(taskId = null) {
    this.db = new DigitalEyesDb();
    return await this.db.AddressPhotoFilesDetails.where("taskId").equals(taskId).and(item => item.UploadStatus == 'false').toArray();
  }
  updateAddressFileDetails(InspectionFile, uploadFileDetails) {
    this.db = new DigitalEyesDb();
    var LocalFileUrl = InspectionFile.LocalFileUrl;
    var uploadStatus = uploadFileDetails.StatusCode == 200 ? 'true' : 'false';
    var LocalFileUrl = uploadStatus == 'true' ? '' : InspectionFile.LocalFileUrl;

    this.db.AddressPhotoFilesDetails.update(InspectionFile.AddressFileId, { UploadStatus: uploadStatus, LocalFileUrl: LocalFileUrl, ServerFileName: uploadFileDetails.Data[0].fileName }).then(function (updated) {
      if (updated) {
        return true;
      }
      else {
        console.log("FileID not found. Nothing was updated");
        return false;
      }
    });
  }

  async updateAddressFileDetailsErrorCase(InspectionFile: any, status: any) {
    await this.db.AddressPhotoFilesDetails.update(InspectionFile.AddressFileId, { UploadStatus: status }).then(function (updated: any) {
    });
  }
}
